<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if (this._isMobile()) {
      console.log("手机端");
      window.location.href = "http://h5.byszdd.com";      
    } 
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>

<style>
  html, body, #app {
    width: 100%;
    height: auto;
    min-height: 100%;
    min-width: 1200px;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  p {
    margin: 0;
    padding: 0;
  }
  ul, li {
    list-style: none;
    margin: 0;
  }
  a {
    text-decoration: none;
    color: #333;
  }
  a:hover {
    text-decoration: none;
    color: #2D58C6;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue